'use client'

import { Fragment, ReactNode, useEffect } from 'react'

import Analytics from '@/lib/utils/analytics'
import { getCookies } from '@/lib/utils/get-cookies'

export default function HubungiKamiWaLayout({ children }: { children: ReactNode }) {
  useEffect(() => {
    const cookieValue = getCookies('utmdt')
    if (!cookieValue) {
      const analyticsData = Analytics()
      const utmCookies: utmType = {
        source: analyticsData.source ?? '-',
        medium: analyticsData.medium ?? '-',
        utmCampaign: analyticsData?.campaign ?? '-',
        utmContent: analyticsData?.content ?? '-',
        utmMedium: analyticsData?.medium ?? '-',
        utmSource: analyticsData?.source ?? '-',
        utmTerms: analyticsData?.terms ?? '-'
      }

      document.cookie = `utmdt=${JSON.stringify(utmCookies)};max-age=300;domain=${window.location.hostname};SameSite=None;Secure`
    }
  }, [])

  return <Fragment>{children}</Fragment>
}
